export default __webpack_public_path__ + "static/media/mental-2021.b55636e1.jpg";